import React from "react";
import { useTranslation } from "react-i18next";

const DepositsCopy = ({
  styles,
  hotelResortId,
  currency,
  amount,
  formatCurrency,
  geo,
  cutOffDate,
  standardCopy,
  refundable
}) => {

  const { t } = useTranslation("common");
  const getCopy = (hotelResortId) => {
    const formattedAmount = formatCurrency(amount.toFixed(2), geo);
    // World Disney World resort ID
    const WDWResortId = 481;

    switch (hotelResortId) {
      case WDWResortId:
        return (
          <>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>1</div>
              <div className={styles.depositsMeta}>
                <h4>
                  {t("non-refundable-deposits-title-1", {
                    amount: formattedAmount
                  })}
                </h4>
                <p>
                  {t("non-refundable-deposits-content-1.standard")}
                  {!refundable && t("non-refundable-deposits-content-1.non-refundable", { amount: formattedAmount })}
                </p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>2</div>
              <div className={styles.depositsMeta}>
                <h4>{t("non-refundable-deposits-title-2")}</h4>
                <p>{t("non-refundable-deposits-content-2")}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>3</div>
              <div className={styles.depositsMeta}>
                <h4>{t("non-refundable-deposits-title-3")}</h4>
                <p>{t("non-refundable-deposits-content-3")}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>4</div>
              <div className={styles.depositsMeta}>
                <h4>{t("non-refundable-deposits-title-4")}</h4>
                <p>
                  {t("non-refundable-deposits-content-4", { date: cutOffDate() })}
                </p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>5</div>
              <div className={styles.depositsMeta}>
                <h4>{t("non-refundable-deposits-title-5")}</h4>
                <p>{t("non-refundable-deposits-content-5")}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>6</div>
              <div className={styles.depositsMeta}>
                <h4>{t("non-refundable-deposits-title-6")}</h4>
              </div>
            </div>
          </>
        );
      default:
        return (
          <>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>1</div>
              <div className={styles.depositsMeta}>
                <h4>
                  {t("deposits-title-1", { amount: formattedAmount })}
                </h4>
                <p>{t("deposits-content-1")}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>2</div>
              <div className={styles.depositsMeta}>
                <h4>{t("deposits-title-2")}</h4>
                <p>{t("deposits-content-2")}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>3</div>
              <div className={styles.depositsMeta}>
                <h4>{t("deposits-title-3")}</h4>
                <p data-testid="deposits-content-3">
                  {t("deposits-content-3", { date: cutOffDate() })}
                </p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>4</div>
              <div className={styles.depositsMeta}>
                <h4>{t("deposits-title-4")}</h4>
                <p>{t("deposits-content-4")}</p>
              </div>
            </div>
          </>
        );
    }
  }

  return (
    <div className={styles.depositsModalContent}>
      <p>{t("deposits-byline")}</p>
      <h4 className={styles.depositsSpacer}>{t("deposits-subheading")}</h4>
      <div className={styles.depositsModalList}>{getCopy(hotelResortId)}</div>
    </div>
  );
};

export default DepositsCopy;
